import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-13e6e1f2")

_pushScopeId("data-v-13e6e1f2")
const _hoisted_1 = {
  class: "container",
  style: {"min-height":"100vh"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查看建议")
const _hoisted_4 = { style: {"position":"fixed","bottom":"89px","right":"50px"} }
_popScopeId()

import { ref, onMounted, reactive, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import wx from 'wx';
import {getmyself} from "@/api/index"
import { questionRecordList } from '@/api/MemberHealthQuestion'
import { watch } from 'vue';
import { getMemberBaseInfo } from '@/api/member'
import { useNavigateTo } from '@/composables/WxXCX'



export default _defineComponent({
  expose: [],
  setup(__props) {

    
const DEFAULT_PAGE_NO = 0;

const data = reactive({
    memberId: null,
    memberBaseInfo: null,
    pageNo: DEFAULT_PAGE_NO,
    dataList: [],
})


const loading = ref(false);
const finished = ref(false);

const onLoad = () => {
    loading.value = true;
    return questionRecordList(data.memberId, data.pageNo).then(respData => {
        console.log("respData", respData);

        // 当前登录的用户ID，根据这个判断是不是本人创建的记录
        const currentUserId = data.memberBaseInfo.createUserId;

        respData.content.forEach(v => {
            v['_isNativeUserCreate'] = v.createUserId === currentUserId

            // status 
            v['_isSubmitted'] = v.status === 10
            v['_isCompleted'] = v.status === 20

            v['_badgeContent'] = v._isSubmitted ? '已提交' : v._isCompleted ? '已完成': '-'
            v['_badgeColor'] = v._isSubmitted ? 'rgba(0,0,0,0)' : v._isCompleted ? '#ee0a24': null
            // v['_iconColor'] = v._isSubmitted ? '#ee0a24' : v._isCompleted ? '#07c160': null
        })

        Array.prototype.push.apply(data.dataList, respData.content);
        data.pageNo++;

        if(data.pageNo === respData.totalPage){
            finished.value = true;
        }
        loading.value = false;

    })
};


const refreshLoading = ref(false);
function refreshDataList() {
    data.pageNo = DEFAULT_PAGE_NO;
    data.dataList = [];
    finished.value = false;

    refreshLoading.value = true
    onLoad().then(()=>{
        refreshLoading.value = false
    });

}


onMounted(async ()=>{

    const memberId = useRoute().query.memberId
    if(memberId){
        data.memberId = memberId;
    }else{
        await getmyself().then(res=>{
            data.memberId = res.id
            console.log("设置当前登录用户的主成员ID", data.memberId);
        });
    }

    // 获取指定成员的基本信息
    await getMemberBaseInfo(data.memberId).then(respData => {
        data.memberBaseInfo = respData
    })

    onLoad();

})

function toHealthQuestionnaire(){
    wx.miniProgram.navigateTo({
    url: '/pages/healthQuestionnaire/healthQuestionnaire?memberId=' + data.memberId,
    })
}


return /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_badge = _resolveComponent("van-badge")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_cell = _resolveComponent("van-cell")
  const _component_van_list = _resolveComponent("van-list")
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshLoading.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (refreshLoading.value = $event)),
      onRefresh: refreshDataList
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          (data.dataList.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_van_list, {
                  loading: loading.value,
                  "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (loading.value = $event)),
                  finished: finished.value,
                  "finished-text": "没有更多了",
                  onLoad: onLoad
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.dataList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_van_cell, {
                        key: index,
                        onClick: ($event: any) => (_unref(useNavigateTo)('/pages/healthQuestionnaire/healthQuestionnaire',{ id: item.id, mode: 'view' }))
                      }, {
                        title: _withId(() => [
                          _createVNode(_component_van_row, null, {
                            default: _withId(() => [
                              _createVNode(_component_van_col, {
                                span: "4",
                                style: {"line-height":"0"}
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_van_badge, {
                                    content: item._badgeContent,
                                    color: item._badgeColor,
                                    offset: ['0','0'],
                                    dot: true
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_van_icon, {
                                        name: "records",
                                        size: "30"
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["content", "color"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_van_col, {
                                span: "15",
                                style: {"display":"flex","align-items":"center"}
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", null, [
                                    _createTextVNode(_toDisplayString(item.createTime) + "   ", 1),
                                    (!item._isNativeUserCreate)
                                      ? (_openBlock(), _createBlock(_component_van_icon, {
                                          key: 0,
                                          name: "friends-o"
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_van_col, {
                                span: "5",
                                style: {"display":"flex","align-items":"center"}
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", null, [
                                    _createVNode(_component_van_button, {
                                      color: "rgb(159, 102, 204)",
                                      onClick: [
                                        _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                                        ($event: any) => (_unref(useNavigateTo)('/pages/healthQuestionnaire/consultationRecord/consultationRecord', { id: item.id,}))
                                      ],
                                      type: "primary",
                                      size: "small"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_3
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "finished"])
              ]))
            : (_openBlock(), _createBlock(_component_van_empty, {
                key: 1,
                image: require('@/assets/img/empty-data.png'),
                "image-size": "80",
                description: "无数据"
              }, null, 8, ["image"]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_van_button, {
        color: "rgba(116, 83, 213, 1)",
        icon: "plus",
        type: "primary",
        style: {"width":"var(--van-button-default-height)"},
        round: "",
        onClick: toHealthQuestionnaire
      })
    ])
  ], 64))
})
}

})